import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";

const FarmerAgingReport = () => {
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [itemsPerPage] = useState(10);

  const { sendRequest: getData } = useHttp();

  const FillDetail = () => {
    getData(
      {
        url: `/api/farmerAgingReportView?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
         // console.log(res.payableReceivablesDetail);
          setData(res.payableReceivablesDetail);
          setAllData(res.payableReceivablesDetail);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getData]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
      item?.mappedName?.includes(filetrtext) ||
      item?.accountName?.includes(filetrtext) ||
      item?.accountCode?.includes(filetrtext) ||
      item?.code?.includes(filetrtext) ||
  
      item?.payReceiptType?.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              &nbsp; &nbsp;Farmer Aging Report
            </label>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered table-responsive text-center">
                        <thead>
                          <tr>
                          <th>Sr No.</th>
                            <th>Farmer Name</th>
                            <th>Account Name</th>
                            <th>Account Code</th>
                            <th>Date</th>
                            <th>Doc</th>
                            <th>Type</th>
                            <th>Total Amount</th>
                            <th>Balance Amount</th>
                            <th>Aging Days</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{x.mappedName}</td>
                                <td>{x.accountName}</td>
                                <td>{x.accountCode}</td>
                                <td>{x.payableReceivablesDate}</td>

                                <td>{x.code}</td>
                                <td>{x.payReceiptType}</td>
                                <td>{x.totalamount}</td>
                                <td>{x.balanceAmount}</td>
                                <td>{x.agingDays}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerAgingReport